/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeContainer, BaSeSmall1, BaSeTheme } from '@base/react';
import { format } from 'date-fns';
import * as React from 'react';

export const DataRegister = ({ props }) => {
  return (
    <BaSeContainer>
      <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
        {format(new Date(props.interviewDate), 'dd/MM/yyyy ')}
      </BaSeSmall1>
    </BaSeContainer>
  );
};
